export default __webpack_public_path__ + "static/media/nearMap.6d34c2fd.png";